module.exports = __webpack_public_path__ + "static/cat-87d0e088731ab641f83eb84c2d4c80ea.webp";